import 'utils/filter_form';
import 'utils/form_data_summary';
import 'utils/autofill_by_query_string';
import 'components/select';
import 'components/alphabetical_input';
import DisciplinesSubjectsSelect from 'utils/disciplines_subjects_select';

// import './index.scss';

(function ($) {
  const $filterForm = $('#js-lessons-filter-form');
  const $disciplineSelect = $('#by_discipline', $filterForm);
  const $subjectSelect = $('#by_subject', $filterForm);

  DisciplinesSubjectsSelect.init($disciplineSelect, $subjectSelect);

  $filterForm.autoFillByQueryString().filterForm().formDataSummary('.js-summary').lazyReady();
})(jQuery);
